
export enum MachineModels {
    NETZSCH = 'NETZSCH',
    CONDUX = 'CONDUX',
    CSM = 'CSM',
    CGS = 'CGS',
    S_JET = 'S_JET',
    CONJET = 'CONJET',
    SECOMY = 'SECOMY',
    CFS = 'CFS',
    TAURUS = 'TAURUS',
    BORA = 'BORA',
    PAMIR = 'PAMIR',
    MASTER_CONCH = 'MASTER_CONCH',
    MASTER_CREAM = 'MASTER_CREAM',
    MASTER_NIBS = 'MASTER_NIBS',
    MASTER_MIX = 'MASTER_MIX',
    PMD = 'PMD',
    DEAERATOR = 'DEAERATOR',
    EPSILON = 'EPSILON',
    MAXSHEAR = 'MAXSHEAR',
    PML = 'PML',
    PMH = 'PMH',
    OMEGA = 'OMEGA',
    PSIMIX = 'PSIMIX',
    GYRHO = 'GYRHO',
    SIERRA = 'SIERRA',
    SCIROCCO = 'SCIROCCO',
    MONSOON = 'MONSOON',
    MISTRAL = 'MISTRAL',
    URAL = 'URAL',
    KAPPA_VITA = 'KAPPA_VITA',
    GAMMA_VITA = 'GAMMA_VITA',
    LAMBDA_VITA = 'LAMBDA_VITA',
    OMEGA_VITA = 'OMEGA_VITA',
    DELTA_VITA = 'DELTA_VITA',
    PUMPS = 'PUMPS',
    TANK = 'TANK',
    PROPHI = 'PROPHI',
    ISAMILL = 'ISAMILL',
    OTHER = 'OTHER'
}

export const MachineModelsTemplate = {
    CONDUX: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Material:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Rotor Execution:</strong>&ensp;</p>
        <p><strong>Stator Execution:</strong>&ensp;</p>
        <p><strong>Revolution:</strong>&ensp;</p>
        <p><strong>Air Volume:</strong>&ensp;</p>
    `,
    CSM: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Material:</strong>&ensp;</p>
        <p><strong>Grinding disc power:</strong>&ensp;</p>
        <p><strong>Classifier power:</strong>&ensp;</p>
        <p><strong>Classifier rotor model:</strong>&ensp;</p>
        <p><strong>Grinding disc speed:</strong>&ensp;</p>
        <p><strong>Classifier speed:</strong>&ensp;</p>
        <p><strong>Air volume:</strong>&ensp;</p>
    `,
    CGS: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Material:</strong>&ensp;</p>
        <p><strong>Classifier power:</strong>&ensp;</p>
        <p><strong>Classifier speed:</strong>&ensp;</p>
        <p><strong>Classifier rotor model:</strong>&ensp;</p>
        <p><strong>Number of nozzles:</strong>&ensp;</p>
        <p><strong>Nozzles diameter:</strong>&ensp;</p>
        <p><strong>Air volume:</strong>&ensp;</p>
        <p><strong>Air pressure:</strong>&ensp;</p>
    `,
    S_JET: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Material:</strong>&ensp;</p>
        <p><strong>Working temperature:</strong>&ensp;</p>
        <p><strong>Classifier rotor model:</strong>&ensp;</p>
        <p><strong>Classifier power:</strong>&ensp;</p>
        <p><strong>Classifier speed:</strong>&ensp;</p>
        <p><strong>Bearing lubrication temperature:</strong>&ensp;</p>
        <p><strong>Number of nozzles:</strong>&ensp;</p>
        <p><strong>Nozzle diameter:</strong>&ensp;</p>
        <p><strong>Steam volume:</strong>&ensp;</p>
        <p><strong>Steam pressure:</strong>&ensp;</p>
    `,
    CONJET: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Material:</strong>&ensp;</p>
        <p><strong>Working temperature:</strong>&ensp;</p>
        <p><strong>Classifier rotor model:</strong>&ensp;</p>
        <p><strong>Classifier power:</strong>&ensp;</p>
        <p><strong>Classifier speed:</strong>&ensp;</p>
        <p><strong>Bearing lubrication temperature:</strong>&ensp;</p>
        <p><strong>Number of nozzles:</strong>&ensp;</p>
        <p><strong>Nozzle diameter:</strong>&ensp;</p>
        <p><strong>Air volume:</strong>&ensp;</p>
        <p><strong>Air pressure:</strong>&ensp;</p>
    `,
    SECOMY: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Rotor Type:</strong>&ensp;</p>
        <p><strong>Number of rotor blades:</strong>&ensp;</p>
        <p><strong>Number of stationary blades:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Speed:</strong>&ensp;</p>
        <p><strong>Sieve Opening:</strong>&ensp;</p>
        <p><strong>Air Flow:</strong>&ensp;</p>
    `,
    CFS: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Classifier rotor model:</strong>&ensp;</p>
        <p><strong>Classifier power:</strong>&ensp;</p>
        <p><strong>Classifier speed:</strong>&ensp;</p>
        <p><strong>Air volume:</strong>&ensp;</p>
        <p><strong>Blower power:</strong>&ensp;</p>
    `,
    TAURUS: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Intern volume:</strong>&ensp;</p>
        <p><strong>Grinding volume:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Speed:</strong>&ensp;</p>
    `,
    BORA: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Classifier power:</strong>&ensp;</p>
        <p><strong>Classifier speed:</strong>&ensp;</p>
        <p><strong>Rotor material:</strong>&ensp;</p>
        <p><strong>Air volume:</strong>&ensp;</p>
        <p><strong>Blower power:</strong>&ensp;</p>
    `,
    PAMIR: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Intern volume:</strong>&ensp;</p>
        <p><strong>Grinding volume:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Speed:</strong>&ensp;</p>
    `,
    MASTER_CONCH: `
        <p><strong>Conch model:</strong>&ensp;</p>
        <p><strong>Conch power:</strong>&ensp;</p>
        <p><strong>Conch material:</strong>&ensp;</p>
        <p><strong>Water heating power:</strong>&ensp;</p>
        <p><strong>Air flow rate:</strong>&ensp;</p>
        <p><strong>Discharge pump flow rate:</strong>&ensp;</p>
        <p><strong>Air heating power:</strong>&ensp;</p>
    `,
    MASTER_CREAM: `
        <p><strong>MasterCream Model:</strong>&ensp;</p>
        <p><strong>MasterCream cutting configuration:</strong>&ensp;</p>
        <p><strong>MasterCream tooth size:</strong>&ensp;</p>
        <p><strong>MasterCream cutting tool material:</strong>&ensp;</p>
        <p><strong>MasterCream drive power:</strong>&ensp;</p>
        <p><strong>MasterCream maximum speed:</strong>&ensp;</p>
        <p><strong>Screw conveyor power:</strong>&ensp;</p>
        <p><strong>Maximum screw conveyor speed:</strong>&ensp;</p>
    `,
    MASTER_NIBS: `
        <p><strong>MasterNibs model:</strong>&ensp;</p>
        <p><strong>MasterNibs drive power:</strong>&ensp;</p>
        <p><strong>MasterNibs material:</strong>&ensp;</p>
        <p><strong>Hydraulic unit:</strong>&ensp;</p>
        <p><strong>Exhaust system:</strong>&ensp;</p>
        <p><strong>Screw conveyor power:</strong>&ensp;</p>
    `,
    MASTER_MIX: `
        <p><strong>MasterMix model:</strong>&ensp;</p>
        <p><strong>MasterMix power:</strong>&ensp;</p>
        <p><strong>Disc diameter:</strong>&ensp;</p>
        <p><strong>Disc model:</strong>&ensp;</p>
        <p><strong>Disc speed (m/s):</strong>&ensp;</p>
        <p><strong>Disc maximum rotation:</strong>&ensp;</p>
        <p><strong>Disc minimum rotation:</strong>&ensp;</p>
        <p><strong>Tank volume:</strong>&ensp;</p>
        <p><strong>Tank maximum height:</strong>&ensp;</p>
        <p><strong>Tank diameter outside:</strong>&ensp;</p>
        <p><strong>Hydraulic unit:</strong>&ensp;</p>
        <p><strong>Scraper:</strong>&ensp;</p>
        <p><strong>Scraper power:</strong>&ensp;</p>
        <p><strong>VacuumSystem:</strong>&ensp;</p>
        <p><strong>Column lift:</strong>&ensp;</p>
        <p><strong>Weight system:</strong>&ensp;</p>
    `,
    PMD: `
        <p><strong>PMD model:</strong>&ensp;</p>
        <p><strong>PMD power:</strong>&ensp;</p>
        <p><strong>Disc diameter:</strong>&ensp;</p>
        <p><strong>Disc model:</strong>&ensp;</p>
        <p><strong>Disc speed (m/s):</strong>&ensp;</p>
        <p><strong>Disc maximum rotation:</strong>&ensp;</p>
        <p><strong>Disc minimum rotation:</strong>&ensp;</p>
        <p><strong>Tank volume:</strong>&ensp;</p>
        <p><strong>Hydraulic unit:</strong>&ensp;</p>
        <p><strong>Scraper:</strong>&ensp;</p>
        <p><strong>Scraper power:</strong>&ensp;</p>
        <p><strong>VacuumSystem:</strong>&ensp;</p>
        <p><strong>Washing system:</strong>&ensp;</p>
        <p><strong>Vertical movement control type:</strong>&ensp;</p>
        <p><strong>Discharge pump:</strong>&ensp;</p>
        <p><strong>Tank type:</strong>&ensp;</p>
        <p><strong>Column lift:</strong>&ensp;</p>
        <p><strong>Weight system:</strong>&ensp;</p>
    `,
    DEAERATOR: `
        <p><strong>Deaerator model:</strong>&ensp;</p>
        <p><strong>Deaerator power:</strong>&ensp;</p>
        <p><strong>Deaerator speed:</strong>&ensp;</p>
        <p><strong>Vacuum pump type:</strong>&ensp;</p>
        <p><strong>Vacuum pump power:</strong>&ensp;</p>
        <p><strong>Vacuum pump flow:</strong>&ensp;</p>
        <p><strong>Valves (manual or automatic):</strong>&ensp;</p>
    `,
    EPSILON: `
        <p><strong>Epsilon model:</strong>&ensp;</p>
        <p><strong>Epsilon power:</strong>&ensp;</p>
        <p><strong>Epsilon stator/rotor system:</strong>&ensp;</p>
        <p><strong>Epsilon stator opening:</strong>&ensp;</p>
        <p><strong>Epsilon maximum speed:</strong>&ensp;</p>
        <p><strong>Recirculation pump flow rate:</strong>&ensp;</p>
        <p><strong>Pump flow rate:</strong>&ensp;</p>
        <p><strong>Feeding system model:</strong>&ensp;</p>
    `,
    MAXSHEAR: `
        <p><strong>Maxshear model:</strong>&ensp;</p>
        <p><strong>Maxshear power:</strong>&ensp;</p>
        <p><strong>Maxshear maximum speed:</strong>&ensp;</p>
        <p><strong>Stator opening:</strong>&ensp;</p>
        <p><strong>Feeding pump flow rate:</strong>&ensp;</p>
    `,
    PML: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Type of mixing tool:</strong>&ensp;</p>
        <p><strong>Tank volume:</strong>&ensp;</p>
        <p><strong>Hydraulic unit:</strong>&ensp;</p>
        <p><strong>Scraper:</strong>&ensp;</p>
        <p><strong>Scraper power:</strong>&ensp;</p>
        <p><strong>Vacuum System:</strong>&ensp;</p>
        <p><strong>Washing system:</strong>&ensp;</p>
        <p><strong>Discharge pump:</strong>&ensp;</p>
        <p><strong>Pressout system:</strong>&ensp;</p>
    `,
    PMH: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Low speed mixing tool type:</strong>&ensp;</p>
        <p><strong>High speed mixing tool type:</strong>&ensp;</p>
        <p><strong>Tank volume:</strong>&ensp;</p>
        <p><strong>Hydraulic unit:</strong>&ensp;</p>
        <p><strong>Scraper:</strong>&ensp;</p>
        <p><strong>Scraper power:</strong>&ensp;</p>
        <p><strong>Vacuum System:</strong>&ensp;</p>
        <p><strong>Washing system:</strong>&ensp;</p>
        <p><strong>Discharge pump:</strong>&ensp;</p>
        <p><strong>Pressout system:</strong>&ensp;</p>
    `,
    OMEGA: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Overpressure pump type:</strong>&ensp;</p>
        <p><strong>Feeding pump type:</strong>&ensp;</p>
        <p><strong>Feeding pump size:</strong>&ensp;</p>
        <p><strong>Dispersion modules types:</strong>&ensp;</p>
    `,
    PSIMIX: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Size:</strong>&ensp;</p>
        <p><strong>Rotary valve type:</strong>&ensp;</p>
        <p><strong>Rotor type:</strong>&ensp;</p>
        <p><strong>Feeding pump type:</strong>&ensp;</p>
        <p><strong>Feeding pump power:</strong>&ensp;</p>
        <p><strong>Tank volume:</strong>&ensp;</p>
        <p><strong>Tank type:</strong>&ensp;</p>
        <p><strong>Type of the mixer in the tank:</strong>&ensp;</p>
    `,
    GYRHO: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Material:</strong>&ensp;</p>
        <p><strong>Grinding disc power:</strong>&ensp;</p>
        <p><strong>Classifier power:</strong>&ensp;</p>
        <p><strong>Classifier rotor model:</strong>&ensp;</p>
        <p><strong>Grinding disc speed:</strong>&ensp;</p>
        <p><strong>Air volume:</strong>&ensp;</p>
    `,
    SIERRA: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Power:</strong>&ensp;</p>
        <p><strong>Feed rate:</strong>&ensp;</p>
        <p><strong>Air throughput:</strong>&ensp;</p>
        <p><strong>Maximum speed:</strong>&ensp;</p>
        <p><strong>Rows of pins - Housing:</strong>&ensp;</p>
        <p><strong>Rows of pins - Door side:</strong>&ensp;</p>
    `,
    SCIROCCO: `
        <p><strong>Scirocco power:</strong>&ensp;</p>
        <p><strong>Air throughput:</strong>&ensp;</p>
        <p><strong>Feed rate:</strong>&ensp;</p>
        <p><strong>Maximum rotor speed:</strong>&ensp;</p>
        <p><strong>Fineness:</strong>&ensp;</p>
    `,
    MONSOON: `
        <p><strong>Monsoon power:</strong>&ensp;</p>
        <p><strong>Feed rate:</strong>&ensp;</p>
        <p><strong>Maximum rotor speed:</strong>&ensp;</p>
        <p><strong>Fineness:</strong>&ensp;</p>
    `,
    MISTRAL: `
        <p><strong>Mistral power:</strong>&ensp;</p>
        <p><strong>Air throughput:</strong>&ensp;</p>
        <p><strong>Feed rate:</strong>&ensp;</p>
        <p><strong>Maximum rotor speed:</strong>&ensp;</p>
        <p><strong>Sealing air throughput:</strong>&ensp;</p>
        <p><strong>Fineness:</strong>&ensp;</p>
    `,
    URAL: `
        <p><strong>Ural power:</strong>&ensp;</p>
        <p><strong>Air throughput:</strong>&ensp;</p>
        <p><strong>Feed rate:</strong>&ensp;</p>
        <p><strong>Maximum rotor speed:</strong>&ensp;</p>
        <p><strong>Maximum mill speed:</strong>&ensp;</p>
        <p><strong>Classifier power:</strong>&ensp;</p>
        <p><strong>Fineness:</strong>&ensp;</p>
    `,
    KAPPA_VITA: `
        <p><strong>KappaVita power:</strong>&ensp;</p>
        <p><strong>Tank size:</strong>&ensp;</p>
        <p><strong>Homogenizer size:</strong>&ensp;</p>
        <p><strong>Surface / Roughness (pipeline):</strong>&ensp;</p>
        <p><strong>Sealing:</strong>&ensp;</p>
        <p><strong>Mechanical seal:</strong>&ensp;</p>
        <p><strong>Heating / Cooling system:</strong>&ensp;</p>
        <p><strong>Pressure system:</strong>&ensp;</p>
        <p><strong>Vacuum system:</strong>&ensp;</p>
        <p><strong>Panel size:</strong>&ensp;</p>
    `,
    GAMMA_VITA: `
        <p><strong>GammaVita power:</strong>&ensp;</p>
        <p><strong>Tank size:</strong>&ensp;</p>
        <p><strong>Circulation agitator size:</strong>&ensp;</p>
        <p><strong>Surface / Roughness (pipeline):</strong>&ensp;</p>
        <p><strong>Sealing:</strong>&ensp;</p>
        <p><strong>Mechanical seal:</strong>&ensp;</p>
        <p><strong>Heating / Cooling system:</strong>&ensp;</p>
        <p><strong>Pressure system:</strong>&ensp;</p>
        <p><strong>Vacuum system:</strong>&ensp;</p>
        <p><strong>Panel size:</strong>&ensp;</p>
    `,
    LAMBDA_VITA: `
        <p><strong>LambdaVita power:</strong>&ensp;</p>
        <p><strong>Tank size:</strong>&ensp;</p>
        <p><strong>Homogenizer size:</strong>&ensp;</p>
        <p><strong>Surface / Roughness (pipeline):</strong>&ensp;</p>
        <p><strong>Sealing:</strong>&ensp;</p>
        <p><strong>Mechanical seal:</strong>&ensp;</p>
    `,
    OMEGA_VITA: `
        <p><strong>OmegaVita power:</strong>&ensp;</p>
        <p><strong>Flow:</strong>&ensp;</p>
        <p><strong>Surface / Roughness (pipeline):</strong>&ensp;</p>
        <p><strong>Panel size:</strong>&ensp;</p>
    `,
    DELTA_VITA: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Electrical Supply Voltage:</strong>&ensp;</p>
        <p><strong>Agitator size:</strong>&ensp;</p>
        <p><strong>Grinding chamber material:</strong>&ensp;</p>
        <p><strong>Beads size:</strong>&ensp;</p>
        <p><strong>Beads material:</strong>&ensp;</p>
        <p><strong>Surface / Roughness (pipeline):</strong>&ensp;</p>
        <p><strong>Sealing:</strong>&ensp;</p>
        <p><strong>Mechanical Seal:</strong>&ensp;</p>
        <p><strong>Sealing liquid system:</strong>&ensp;</p>
        <p><strong>Panel size:</strong>&ensp;</p>
        <p><strong>SIP (Sterilization):</strong>&ensp;</p>
    `,
    PUMPS: `
        <p><strong>Pump power:</strong>&ensp;</p>
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Material of construction:</strong>&ensp;</p>
        <p><strong>Minimum flow:</strong>&ensp;</p>
        <p><strong>Maximum flow:</strong>&ensp;</p>
        <p><strong>Minimum speed:</strong>&ensp;</p>
        <p><strong>Maximum speed:</strong>&ensp;</p>
    `,
    TANK: `
        <p><strong>Type (design of the tank):</strong>&ensp;</p>
        <p><strong>Volume NET (working):</strong>&ensp;</p>
        <p><strong>Volume GROSS (total):</strong>&ensp;</p>
        <p><strong>Material of construction:</strong>&ensp;</p>
        <p><strong>Surface description:</strong>&ensp;</p>
        <p><strong>Cooling type (design):</strong>&ensp;</p>
        <p><strong>Height:</strong>&ensp;</p>
        <p><strong>Diameter:</strong>&ensp;</p>
        <p><strong>Scrapper: YES/NO</strong>&ensp;</p>
        <p><strong>Mixer type:</strong>&ensp;</p>
        <p><strong>Mixer power:</strong>&ensp;</p>
        <p><strong>Mixing tool type:</strong>&ensp;</p>
        <p><strong>Diameter of mixing tool:</strong>&ensp;</p>
        <p><strong>Minimum speed of the mixing tool:</strong>&ensp;</p>
        <p><strong>Maximum speed of the mixing tool:</strong>&ensp;</p>
    `,
    PROPHI: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Type:</strong>&ensp;</p>
        <p><strong>Grinding Technology:</strong>&ensp;</p>
        <p><strong>Inner Liner Material:</strong>&ensp;</p>
        <p><strong>Sieve Size:</strong>&ensp;</p>
        <p><strong>Bead Material:</strong>&ensp;</p>
        <p><strong>Bead Size 1:</strong>&ensp;</p>
        <p><strong>Bead Size 2:</strong>&ensp;</p>
        <p><strong>Bead Filling Level:</strong>&ensp;</p>
    `,
    ISAMILL: `
        <p><strong>Model:</strong>&ensp;</p>
        <p><strong>Type:</strong>&ensp;</p>
        <p><strong>Grinding Technology:</strong>&ensp;</p>
        <p><strong>Inner Liner Material:</strong>&ensp;</p>
        <p><strong>Sieve Size:</strong>&ensp;</p>
        <p><strong>Bead Material:</strong>&ensp;</p>
        <p><strong>Bead Size 1:</strong>&ensp;</p>
        <p><strong>Bead Size 2:</strong>&ensp;</p>
        <p><strong>Bead Filling Level:</strong>&ensp;</p>
    `
};

/**
 * Retrieves the machine template HTML string based on the provided machine model.
 *
 * @param {MachineModels} model - The machine model enum value.
 * @returns {string} - The corresponding HTML template from `MachineModelsTemplate`.
 */
export function getMachineTemplate(model: MachineModels): string {
    // Define a mapping from enum values to object keys
    const modelKey = model as keyof typeof MachineModelsTemplate;
  
    // Return the corresponding template or a default message if not found
    return MachineModelsTemplate[modelKey];
}
